import { ContactMethodErrorModel } from "./ContactMethodError.model";

export class ContactMethodError extends ContactMethodErrorModel {
    // Add custom methods here
}
